import { message } from "antd";
import axios from "axios";
import { BASE_URL } from "../../constant/api";

export const getAllKcm = () => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    dispatch({ type: 'KCMS_LOADED', payload: false })
    try {
        const response = await axios.get(BASE_URL + '/api/kcm')
        dispatch({ type: 'GET_ALL_KCMS', payload: response.data })
        dispatch({ type: 'KCMS_LOADED', payload: true })
        dispatch({ type: 'LOADING', payload: false })
        console.log(response.data)
    } catch (error) {
        console.log(error)
        dispatch({ type: 'KCMS_LOADED', payload: true })
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const postKcm = (values) => async dispatch => {

    values.postedBy = JSON.parse(localStorage.getItem('user'))._id

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + '/api/kcm', values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('Kcm posted successfully')

        setTimeout(() => {
            window.location.href = '/kcm'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const editKcm = (values) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + "/api/kcm/" + values._id, values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('Kcm edited successfully')

        setTimeout(() => {
            window.location.href = '/kcm'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const deleteKcm = (values) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + "/api/kcm", values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('Kcm deleted successfully')

        setTimeout(() => {
            window.location.href = '/kcm'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const importExcel = (values) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + "/api/import-file", values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('File uploaded successfully')

        setTimeout(() => {
            window.location.href = '/kcm'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};